'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus, faFlame } from '@fortawesome/pro-solid-svg-icons';
import { MAX_ZOOM, MIN_ZOOM, ZOOM_STEP } from '../../constants';
import { LOCATION } from 'src/hooks/filters/constants';
import useStrategies from 'src/hooks/strategy/useStrategies';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
import { HEATMAP_DRAWER_ID } from '../HeatmapControls/HeatmapControls';
import { RoutesDrawerToggle } from 'src/components/Routes/panels/RoutesDrawer';
import { useFlags } from 'launchdarkly-react-client-sdk';

const StrategyMapControls = () => {
  const { useWebRouting } = useFlags();
  const { zoom, setZoom, showHeatmap } = useStrategies(
    LOCATION.STRATEGY_CENTER
  );
  const { openDrawer } = useDrawer();

  const handleZoomIn = () => {
    if (zoom >= MAX_ZOOM) return;
    setZoom(zoom + ZOOM_STEP);
  };

  const handleZoomOut = () => {
    if (zoom <= MIN_ZOOM) return;
    setZoom(zoom - ZOOM_STEP);
  };

  const handleOpenHeatmapDrawer = () => {
    openDrawer(HEATMAP_DRAWER_ID);
  };

  return (
    <div className="absolute bottom-5 left-5 z-40 inline-flex flex-col justify-start items-start gap-2">
      {/* Routes drawer toggle button - positioned on map */}
      {useWebRouting && <RoutesDrawerToggle />}
      <div className="bg-white rounded-lg shadow-[0px_8px_8px_0px_rgba(0,0,0,0.08)] border border-neutral-200 inline-flex flex-col overflow-hidden">
        <button
          onClick={handleOpenHeatmapDrawer}
          aria-label="Open heatmap metrics"
          className={`font-semibold transition-all duration-200 select-none text-base
           active:bg-neutral-200  p-4 flex items-center justify-center rounded-none
            ${
              showHeatmap
                ? 'bg-red-600 text-white hover:bg-red-700'
                : 'bg-neutral-50 text-neutral-700  hover:bg-neutral-100'
            }
          `}
          data-testid="heatmap-button"
        >
          <Icon icon={faFlame} className="font-bold " />
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-[0px_8px_8px_0px_rgba(0,0,0,0.08)] border border-neutral-200 inline-flex flex-col overflow-hidden">
        <button
          onClick={handleZoomIn}
          disabled={zoom >= MAX_ZOOM}
          className="font-semibold transition-all duration-200 select-none text-base bg-neutral-50 text-neutral-700 hover:bg-neutral-100 active:bg-neutral-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-500 disabled:bg-neutral-100 disabled:text-neutral-400 p-4 flex items-center justify-center rounded-none"
          data-testid="zoom-in-button"
        >
          <Icon icon={faPlus} className="text-neutral-600 font-bold w-4 h-4" />
        </button>
        <div className="w-full h-px px-4">
          <div className="h-0 border border-neutral-200"></div>
        </div>
        <button
          onClick={handleZoomOut}
          disabled={zoom <= MIN_ZOOM}
          className="font-semibold transition-all duration-200 select-none text-base bg-neutral-50 text-neutral-700 hover:bg-neutral-100 active:bg-neutral-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-500 disabled:bg-neutral-100 disabled:text-neutral-400 p-4 flex items-center justify-center rounded-none"
          data-testid="zoom-out-button"
        >
          <Icon icon={faMinus} className="text-neutral-600 font-bold w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default StrategyMapControls;
